module.exports = __webpack_public_path__ + "img/lasource-16.00f7c482.jpg";